"use client";

import * as stylex from "@stylexjs/stylex";
export function Handle(props) {
  const {
    gridColumn,
    lock,
    edge,
    iframeRef
  } = props;
  return <div className="xp2yjw4 x1ypdohk x78zum5 x6s0dn4 xl56j7k xbyyjgo x1cdhzux x1cum3z5 xblhjk6 x1o7uuvo x10xrfx7 x1kpm4h4" onMouseDown={() => {
    lock.current = edge;
    if (iframeRef.current) {
      iframeRef.current.style.userSelect = "none";
      iframeRef.current.style.pointerEvents = "none";
    }
  }} style={{
    gridColumn
  }}>
      <svg width="56" height="56" viewBox="0 0 56 56">
        <path fill="currentColor" d="M27 18h2v20h-2V18zm-6 0h2v20h-2V18zm12 0h2v20h-2V18z" />
      </svg>
    </div>;
}